/* @jsx m */
import m from 'mithril';

export default class GameContainer {
  view(vnode) {
    const classes = ['passage'];
    if(vnode.attrs.visible == false) { classes.push('hide') };
    classes.push(vnode.attrs.direction);
    
    return (
      <div class={ classes.join(' ') }>
        <div class="passage-wrapper">
        {vnode.children}
        </div>
      </div>
    );
  }
}
